import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_ROUTE_PAYMENT_RESET = 'POST_ROUTE_PAYMENT_RESET';
export const POST_ROUTE_PAYMENT_LOADING = 'POST_ROUTE_PAYMENT_LOADING';
export const POST_ROUTE_PAYMENT_SUCCESS = 'POST_ROUTE_PAYMENT_SUCCESS';
export const POST_ROUTE_PAYMENT_REJECT = 'POST_ROUTE_PAYMENT_REJECT';

//* ACTIONS ------------------------------------------------
export const postRoutePaymentReset = () => ({ type: POST_ROUTE_PAYMENT_RESET });
export const postRoutePaymentLoading = () => ({ type: POST_ROUTE_PAYMENT_LOADING });
export const postRoutePaymentSuccess = (payload) => ({ type: POST_ROUTE_PAYMENT_SUCCESS, payload });
export const postRoutePaymentReject = (payload) => ({ type: POST_ROUTE_PAYMENT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postRoutePaymentRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/Route/web/AddRouteBilling`, options);
};
